module.exports = __webpack_public_path__ + "img/status-success.efdef48c.svg";